<template>
  <div class="krj-searchbar">
    <slot />
    <div v-if="showActions" class="krj-searchbar__actions">
      <el-button v-if="hasSearch" type="primary" size="small" @click="$emit('search')">查询</el-button>
      <el-button v-if="hasReset" size="small" @click="$emit('reset')">重置</el-button>
    </div>
  </div>
</template>

<script>
/**
 * SearchBar — 筛选表单容器 + 自动渲染「查询/重置」按钮（紧跟查询条件之后）。
 * - 默认插槽放置 <el-form :inline> 的筛选项；
 * - 父级绑定 @search / @reset 时，自动在查询条件之后渲染「查询/重置」按钮（不居右）；
 * - 其余业务操作按钮（新增/导入等）放页面级 <div class="krj-toolbar__actions">（与 search-bar 并列、居右）。
 */
export default {
  name: 'SearchBar',
  computed: {
    hasSearch() {
      return !!this.$listeners.search
    },
    hasReset() {
      return !!this.$listeners.reset
    },
    showActions() {
      return this.hasSearch || this.hasReset
    }
  }
}
</script>
